import * as React from "react";
import { cn } from "@/lib/utils";

import "../data-foundations.css";

export type SelectionScope = "none" | "some" | "page" | "all-results";

export function resolveSelectionScope({
  selectedCount,
  pageCount,
  totalCount,
}: {
  selectedCount: number;
  pageCount: number;
  totalCount?: number;
}): SelectionScope {
  if (selectedCount <= 0) return "none";
  if (totalCount !== undefined && totalCount > 0 && selectedCount >= totalCount)
    return "all-results";
  if (pageCount > 0 && selectedCount >= pageCount) return "page";
  return "some";
}

type SelectionToolbarProps = React.HTMLAttributes<HTMLDivElement> & {
  selectedCount: number;
  scope: SelectionScope;
};

export const SelectionToolbar = React.forwardRef<
  HTMLDivElement,
  SelectionToolbarProps
>(({ children, className, selectedCount, scope, ...props }, ref) => (
  <div
    ref={ref}
    role="toolbar"
    className={cn("selection-toolbar", className)}
    data-selection-count={selectedCount}
    data-selection-scope={scope}
    {...props}
  >
    {children}
  </div>
));
SelectionToolbar.displayName = "SelectionToolbar";
